export * from './lib/platform-settings-api.module';
export * from './lib/platform-settings-api.service';
